import { isSimpleSubscription } from '../../helpers/slug'

export default function SubscriptionCartInfo({ variation }) {
    const product = variation?.item || variation

    if (!product) return null

    const isSimple = isSimpleSubscription(product)

    let subscriptionPeriod = (
        product?.attributes?.find(
            ({ name }) => name === 'Subscription Period',
        ) || {}
    )?.option

    if (isSimple) {
        subscriptionPeriod =
            'Every ' +
            (
                product?.meta_data?.find(
                    ({ key }) => key === '_subscription_period',
                ) || {}
            )?.value
    }

    const price = product.price

    return (
        <div className="px-4 bg-white py-2 my-5">
            <div className="my-4 text-sm">
                <div className="w-full flex justify-between gap-2 my-4">
                    <span className="block truncate text-gray-500">
                        {subscriptionPeriod}
                    </span>
                    <span className="block truncate text-gray-800 font-semibold text-lg">
                        ${Number(price).toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    )
}
